import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "photoshop-product-specific-manifest"
    }}>{`Photoshop Product specific manifest`}</h1>
    <p>{`In addition to the common UXP manifest attributes, Photoshop has an additional key/value field `}<inlineCode parentName="p">{`apiVersion`}</inlineCode>{`. This field is located under the `}<inlineCode parentName="p">{`data`}</inlineCode>{` object inside the `}<inlineCode parentName="p">{`host`}</inlineCode>{` value.
The following illustrates the use of the `}<inlineCode parentName="p">{`apiVersion`}</inlineCode>{` field.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "manifestVersion": 4,
    "id": "YOUR_ID_HERE",
    "name": "Name of your plugin",
    "version": "1.0.0",
    "main": "index.html",
    "host": {
        "app": "PS",
        "minVersion": "23.0.0",
        "data" : {
          "apiVersion": 2,
          "loadEvent": "use"
        }
    },
}
`}</code></pre>
    <h2 {...{
      "id": "apiversion"
    }}>{`apiVersion`}</h2>
    <p>{`A limitation of the UXP implementation in Photoshop 2021 is that it does not provide a mechanism for plugins to run in isolation. Photoshop 2021 allows any plugin to modify Photoshop at any time. This includes scenarios when other plugins are active.`}</p>
    <p>{`Photoshop 2022 has removed this limitation by introducing the modal JavaScript scope. Only one plugin can be inside a modal JavaScript scope at any time. See `}<a parentName="p" {...{
        "href": "../../../../../ps_reference/media/executeasmodal/"
      }}>{`executeAsModal`}</a>{` for details.`}</p>
    <p>{`The modal scope feature is not compatible with the original implementation because it imposes restrictions on when plugins may modify Photoshop.
It is these restrictions that guarantee against multiple plugins modifying Photoshop at the same time.`}</p>
    <p>{`In order to allow plugin developers to gradually move to the new model, Photoshop 2022 supports both the original and the new JavaScript modes. A plugin uses the apiVersion field to specify which model it uses.`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`apiVersion`}</inlineCode>{` of `}<strong parentName="li">{`1`}</strong>{` signifies that the plugin is using the original Photoshop 2021 implementation.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`apiVersion`}</inlineCode>{` of `}<strong parentName="li">{`2`}</strong>{` signifies that the plugin is using the new modal JavaScript feature.`}</li>
    </ul>
    <p>{`With the introduction of apiVersion = 2, the original implementation is formally deprecated, and support for apiVersion 1 will be removed in a future major update to Photoshop. As such a number of new features are only available for apiVersion 2 plugins. apiVersion 2 only features include: new DOM v2, support for suspend and resume of multiple history states at the same time.`}</p>
    <h3 {...{
      "id": "default-value"
    }}>{`Default value`}</h3>
    <p>{`The apiVersion field is optional. Its default value depends on the version of Photoshop that a plugin is targeting:`}</p>
    <ul>
      <li parentName="ul">{`A plugin whose minimum version is less than 23.0.0, will be assigned an apiVersion of 1 unless the plugin specifies otherwise in its manifest.`}</li>
      <li parentName="ul">{`A plugin whose minimum version is 23.0.0, or greater, will be assigned an apiVersion of 2 unless the plugin specifies otherwise in its manifest.`}</li>
    </ul>
    <h3 {...{
      "id": "why-downgrade"
    }}>{`Why downgrade?`}</h3>
    <p>{`Most plugins will be able to use apiVersion 2.`}</p>
    <p>{`Specialized plugins that rely on the Photoshop menu state, or on other non-modal user interactions while the plugin is running may need to stay with apiVersion 1 until such use cases are fully supported by Photoshop.`}</p>
    <h2 {...{
      "id": "loadevent"
    }}>{`loadEvent`}</h2>
    <blockquote>
      <p parentName="blockquote"><inlineCode parentName="p">{`Available in Photoshop 23.1 and later`}</inlineCode></p>
    </blockquote>
    <p>{`Plugins use memory and CPU resources when loaded. In order to minimize the impact on general Photoshop performance, plugins are by default loaded only when needed. The default mechanism will load a plugin when its panel UI becomes visible, or when the user chooses to execute a plugin command from the `}<inlineCode parentName="p">{`Plugins`}</inlineCode>{` menu.`}</p>
    <p>{`Certain use cases require that a plugin is loaded when Photoshop is launched. Such use cases include plugins that listen and respond to user actions, and plugins that needs to communicate with a remote server or process when Photoshop is running.`}</p>
    <p>{`The loadEvent field allows a plugin to specify when it is loaded. The possible values are:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`use`}</inlineCode>{`: The plugin is loaded when needed (when its UI become visible, or when a plugin command is executed). This is the default value.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`startup`}</inlineCode>{`: The plugin is loaded automatically shortly after Photoshop is launched.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      